// @flow
import React from "react"
import Button from "components/Button"
import { Text } from "componentsStyled/Typography/Texts"
import { ConfirmWrap, ConfirmationWrapper, VerificationCode, VerificationCodeInput,
 Verification, VerificationOptions } from "./styled"
import { compose, withHandlers, withStateHandlers, type HOC } from "recompose"
import getErrorMessage from "common/graphql/getErrorMessage"
import { mutate } from "global/apolloClient/helpers"
import { affiliateOnboardSendVerificationCode } from "data/affiliate/mutations"
import withConnect from "hoc/withConnect"
import withMutation from "hoc/withMutation"
import withRouter from "hoc/withRouter"
import withSubmit from "hoc/withSubmit"
import { notificationError } from "data/notifications/actions"
import urls from "data/router/urls"
import { affiliateOnboard } from "data/affiliate/mutations"
import { clear } from "data/search/actions"
import type { GooglePlace } from "data/locations/types"

const Confirm = ({
  verificationRequested,
  requestVerification,
  onChangeVerificationCode,
  submit,
  loading,
}) => (
  <React.Fragment>
    <ConfirmationWrapper>
    <Verification>
      <Text uppercase bold inline>Whats the best way to reach you?</Text>&nbsp;
      <VerificationOptions>
      <Button secondary onClick={() => requestVerification('sms')}>
        SMS to receive
      </Button>
      <Button secondary onClick={() => requestVerification('call')}>
        Call to receive
      </Button>
      </VerificationOptions>
    </Verification>
    { verificationRequested ?
    <VerificationCode>
      <Text inline>Please enter your verification code:</Text>&nbsp;
      <Text small inline> If you do not receive your code within a minute please try again</Text>&nbsp;
      <Text lh={3}>
        <VerificationCodeInput required maxLength="6" type="text" name="verificationCode" label="Verification code" onChange={onChangeVerificationCode} />
      </Text>
    </VerificationCode> : undefined }
    <ConfirmWrap>
      <Button loading={loading} disabled={loading} onClick={submit}>
        Go Live with AwayCo
      </Button>
    </ConfirmWrap>
    </ConfirmationWrapper>
  </React.Fragment>
)

type Outter = {
  inventory: any,
  affiliate: ?GooglePlace,
  // TODO(ray>harry): In what way is this different to the email in `affiliate`?
  // NOTE(HARRY) this should be kept because we are going to not pass the affiliate to the server, only affiliate email etc.
  affiliateEmail: string,
  loading: boolean,
  setLoading: (loading: boolean) => void,
  verificationCode: string,
  setVerificationCode: (verificationCode: string) => void,
}

const mapDispatchToProps = {
  clear,
  notificationError,
}

const enhancer: HOC<*, Outter> = compose(
  withConnect(() => ({}), mapDispatchToProps),
  withRouter,
  withStateHandlers(
    {
      verificationRequested: false,
    },
    {
      requestVerification: (state, props) => (method: any) => {
        if (!props.affiliate) {
          // Should not happen once we're at this step
          return { verificationRequested: false }
        }

        void mutate(affiliateOnboardSendVerificationCode, {
          input: {
            placeId: props.affiliate.placeId,
            affiliateEmail: props.affiliateEmail,
            method,
          }
        })
        return { verificationRequested: true }
      },
    }
  ),
  withHandlers(
    {
      onChangeVerificationCode: props => (event) => {
        props.setVerificationCode(event.target.value)
      }
    }
  ),
  withMutation(affiliateOnboard),
  withSubmit({
    errorText: "Something went wrong!",
    submit: props => () => {
      const input = {
        ...props.affiliate,
        affiliateEmail: props.affiliateEmail,
        productInventory: props.inventory,
        verificationCode: props.verificationCode,
      }
      return props.submitMutation({ input })
    },
    onSuccess: props => results => {
      props.clear()
      props.setLoading(false)
      props.history.push(urls.welcomeToAwayco)
    },
    onError: props => error => {
      props.setLoading(false)
      return getErrorMessage(error) === "Unknown error occured"
        ? "Please fill out all fields and select your inventory"
        : getErrorMessage(error)
    },
  }),
)
export default enhancer(Confirm)



// WEBPACK FOOTER //
// ./src/pages/AffiliateRegistration/Confirm/index.js